export const POSITIVE_NUMBER_PATTERN = /^\d*(\.|,)?\d*$/;
export const WHOLE_NUMBER_PATTERN = /^\d+$/;
export const PERCENTAGE_NUMBER_PATTERN = /(^100(\.0{1,2})?$)|(^([1-9]([0-9])?|0)(\.[0-9]{1,3})?$)/;
export const PERCENTAGE_NEGATIVE_NUMBER_PATTERN =
  /(^-?100(\.0{1,2})?$)|(^-?([1-9]([0-9])?|0)(\.[0-9]{1,3})?$)/;
export const NUMBER_WITH_ONE_FRACTION_DIGIT = /^[-+]?\d{1,}(?:[.,]\d{1})?$/;
export const NUMBER_WITH_TWO_FRACTION_DIGITS = /^[-+]?\d{1,}(?:[.,]\d{1,2})?$/;
export const NEGATIVE_AND_POSITIVE_NUMBER_PATTERN = /^[-+]?[0-9]+(?:[.,][0-9]+)?$/;
export const FLOAT_POSITIVE_NUMBER_PATTERN = /^\d+([.,]\d+)?$/;
export const WHOLE_NUMBER_HIGHER_THAN_ZERO_PATTERN = /^[1-9]\d*$/;
export const FLOAT_POSITIVE_NUMBER_HIGHER_THAN_ZERO_PATTERN = /^(?:[1-9]\d*|0)(?:[.,]\d+)?$/;

export function isNumber(value: unknown) {
  return typeof value === 'number';
}

export function formatNumber(
  locale: string,
  value: number | null | undefined,
  minimumFractionDigits?: number | undefined,
  maximumFractionDigits?: number | undefined,
): string {
  if (value == null) return '';
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(value);
}

export function formatNumberInput(locale: string, value: number | null | undefined): string {
  if (value == null) return '';
  return new Intl.NumberFormat(locale, { useGrouping: false }).format(value);
}

export function parseNumberInput(value: string): number {
  const cleaned = value.replace(',', '.').replaceAll(' ', '').replaceAll('\xa0', '');
  return parseFloat(cleaned);
}

export function formatPercent(locale: string, value: number | null | undefined): string {
  if (value == null) return '';
  return new Intl.NumberFormat(locale, {
    style: 'percent',
    maximumFractionDigits: 3,
  }).format(value);
}

export function formatPercentInput(locale: string, value: number | null | undefined): string {
  if (value == null) return '';
  return formatNumberInput(locale, value * 100);
}

export function parsePercentInput(value: string): number {
  return parseFloat((parseNumberInput(value) / 100).toPrecision(4));
}

export function valueWithScaleToString(value: number, scale: number) {
  const valueAsString = value.toString();
  const decimalIndex = valueAsString.length - scale;

  if (decimalIndex === valueAsString.length) return valueAsString;

  if (decimalIndex > 0) {
    return valueAsString.slice(0, decimalIndex) + '.' + valueAsString.slice(decimalIndex);
  }

  return '0.' + '0'.repeat(-decimalIndex) + valueAsString;
}

export function valueWithScaleToNumber(value: number, scale: number) {
  return value / 10 ** scale;
}

export function stringToValueWithScale(value: string) {
  const decimalIndex = value.indexOf('.');
  const valueAsNumber = parseInt(value.replace('.', ''));
  const scale = decimalIndex === -1 ? 0 : value.length - decimalIndex - 1;

  return { value: valueAsNumber, scale };
}
